var React = require('react');

module.exports = React.createClass({
  render: function() {
    var baseProps = {
      'width': '26px',
'height': '26px',
'viewBox': '0 0 26 26',
'version': '1.1',
'xmlns': 'http://www.w3.org/2000/svg',
'xmlnsXlink': 'http://www.w3.org/1999/xlink',
      className: 'svg-icon',
      dangerouslySetInnerHTML: {
        __html: " <!-- Generator: Sketch 45.2 (43514) - http://www.bohemiancoding.com/sketch --> <title>assets/correct</title> <desc>Created with Sketch.</desc> <defs></defs> <g id=\"CANDIDATE-VIEW\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"> <g id=\"Post-Assessment-1-Report\" transform=\"translate(-299.000000, -3282.000000)\"> <g id=\"Body-Segment\" transform=\"translate(180.000000, 192.000000)\"> <g id=\"Section-2\" transform=\"translate(0.000000, 2234.000000)\"> <g id=\"Problem-1-Copy-3\" transform=\"translate(58.000000, 769.000000)\"> <g id=\"assets/correct\" transform=\"translate(62.000000, 88.000000)\"> <circle id=\"Oval-2\" fill=\"#E0FFEB\" cx=\"12\" cy=\"12\" r=\"8.91015467\"></circle> <circle id=\"Oval-2-Copy-4\" stroke=\"#67D483\" stroke-width=\"2\" cx=\"12\" cy=\"12\" r=\"11.878514\"></circle> <polygon id=\"Shape\" fill=\"#67D483\" points=\"9.94378228 14.3131561 7.54499881 11.9143726 6.74540432 12.7139671 9.94378228 15.9123451 16.7974493 9.058678 15.9978548 8.25908351\"></polygon> </g> </g> </g> </g> </g> </g> ",
      }
    };
    var props = Object.assign({}, baseProps, this.props);
    return React.createElement('svg', props);
  },
});



// WEBPACK FOOTER //
// ./node_modules/dk-ui-lib/assets/correct.svg